const ValidationUtils = {
	getFieldWrapper: (fieldType) => {
		switch (fieldType) {
			case 'radio':
				return '.lta-form-check-group';

			case 'checkbox':
				return '.lta-form-checkbox';

			case 'date':
				return '.lta-text-dob';

			case 'select':
			case 'select-one':
				return '.lta-select';

			default:
				return '.lta-text-input__wrapper';
		}
	},
	getErrorClasses: (fieldType) => {
		switch (fieldType) {
			case 'radio':
			case 'password':
			case 'checkbox':
			case 'date':
			case 'select':
				return ['is-invalid', 'is-focused'];

			default:
				return ['is-invalid', 'is-focused', 'has-icon'];
		}
	},

	isValidEmail: (email = '') => {
		return /^[a-zA-Z0-9](?!.*[._%+-]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/i.test(
			String(email).trim()
		);
	}
};

export default ValidationUtils;
